import { SearchResultItem } from '@xiag-search/sdk';
import { SearchResultSectionType } from 'src/state/SearchResult';

export function getItemSectionType(searchItem: SearchResultItem): SearchResultSectionType {
    const objectType = searchItem.customFields['object-type'];
    return typeof objectType === 'string' && MAPPING[objectType]
        ? MAPPING[objectType]
        : 'information';
}

const MAPPING: Readonly<Record<string, SearchResultSectionType>> = {
    topic: 'activities',
    activity: 'activities',
    gps: 'activities',
    sightseeing: 'activities',
    museum: 'activities',
    offer: 'activities',
    maps: 'activities',

    booking: 'offers',

    hotel: 'accommodations',
    fewo: 'accommodations',
    group_accommodation: 'accommodations',
    privateroom: 'accommodations',
    lodge: 'accommodations',

    event: 'events',
    topevent: 'events',
    news: 'events',
    media: 'events',

    shopping: 'shopping',
    vermietung: 'shopping',
    gastronomie: 'shopping',
};
